// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.stat-insight {
  box-sizing: border-box;
  display: block;
  padding: 64px 16px 8px;
  margin: 1em 0;
  background: #F7F9FC;
  border-radius: 6px;
  position: relative;
  color: #1E2532;
}

.stat-insight:before {
  content: "Statistical Insight";
  position: absolute;
  font-family: sans-serif;
  display: block;
  font-weight: 600;
  font-size: 12px;
  line-height: 16px;
  top: 20px;
  left: 16px;
  right: 16px;
  padding-bottom: 20px;
  color: #656E83;
  border-bottom: 1px solid #E7EAF4;
}
`, "",{"version":3,"sources":["webpack://./src/plugins/stat-insight/styles.css"],"names":[],"mappings":"AAAA;EACE,sBAAsB;EACtB,cAAc;EACd,sBAAsB;EACtB,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,8BAA8B;EAC9B,kBAAkB;EAClB,uBAAuB;EACvB,cAAc;EACd,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,SAAS;EACT,UAAU;EACV,WAAW;EACX,oBAAoB;EACpB,cAAc;EACd,gCAAgC;AAClC","sourcesContent":[".stat-insight {\n  box-sizing: border-box;\n  display: block;\n  padding: 64px 16px 8px;\n  margin: 1em 0;\n  background: #F7F9FC;\n  border-radius: 6px;\n  position: relative;\n  color: #1E2532;\n}\n\n.stat-insight:before {\n  content: \"Statistical Insight\";\n  position: absolute;\n  font-family: sans-serif;\n  display: block;\n  font-weight: 600;\n  font-size: 12px;\n  line-height: 16px;\n  top: 20px;\n  left: 16px;\n  right: 16px;\n  padding-bottom: 20px;\n  color: #656E83;\n  border-bottom: 1px solid #E7EAF4;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
